import { Injectable } from '@angular/core';
import {
  AclAssetModulePermission,
  AclAssetPermission,
  AclAssetResourceType,
  AclOrgSpacePermission,
  AclPermissionDetail,
  AclResourceTypeToAssetModuleResourceType,
} from '@y42/acl/models';
import { OrgSpaceAclService } from '@y42/org-space/acl';
import { AssetAclService } from './asset-acl.service';
import { AssetModuleAclService } from './asset-module-acl.service';

@Injectable({ providedIn: 'root' })
export class FeatureAclQuery {
  constructor(
    private readonly orgSpaceAclService: OrgSpaceAclService,
    private readonly assetModuleAclService: AssetModuleAclService,
    private readonly assetAclService: AssetAclService,
  ) {}

  getPermission({
    resourceType,
    assetPath,
    permission,
  }: {
    resourceType: AclAssetResourceType;
    assetPath: string;
    permission: AclAssetPermission;
  }): AclPermissionDetail | null {
    if (permission === AclAssetPermission.Read) {
      const areAllResourcesFromActiveSpaceReadable = this.orgSpaceAclService.getOrgSpacePermission({
        permission: AclOrgSpacePermission.ReadAllResources,
      });

      if (areAllResourcesFromActiveSpaceReadable?.allowed) {
        return { allowed: true };
      }

      const assetModuleResourceType = AclResourceTypeToAssetModuleResourceType[resourceType];

      const areAllResourcesFromAssetModuleReadable = this.assetModuleAclService.getAssetModulePermission({
        resourceType: assetModuleResourceType,
        permission: AclAssetModulePermission.ReadAllResources,
      });

      if (areAllResourcesFromAssetModuleReadable?.allowed) {
        return { allowed: true };
      }
    }

    return this.assetAclService.getAssetPermission({
      resourceType,
      assetPath,
      permission,
    });
  }
}
